var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 32,
    height: 32,
    id: "user",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C1C1C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm1 29.125A1.874 1.874 0 0 1 29.125 31H2.875A1.874 1.874 0 0 1 1 29.125V2.875C1 1.839 1.839 1 2.875 1h26.25C30.161 1 31 1.839 31 2.875v26.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.37 16.672A4.968 4.968 0 0 0 21 13a5 5 0 0 0-10 0c0 1.458.634 2.758 1.63 3.672C9.332 18.006 7 21.224 7 25h18c0-3.776-2.332-6.994-5.63-8.328zM12 13a4 4 0 1 1 6.26 3.298c-.05.034-.106.06-.158.092-.145.09-.295.174-.452.245-.077.035-.158.065-.238.095-.15.057-.304.105-.462.143-.075.018-.149.039-.226.053-.235.044-.476.074-.724.074s-.489-.03-.725-.073c-.077-.014-.151-.035-.226-.053a4.194 4.194 0 0 1-.462-.143c-.08-.03-.16-.06-.238-.095a3.934 3.934 0 0 1-.452-.245c-.052-.032-.108-.058-.158-.092A3.998 3.998 0 0 1 12 13zM8.069 24a8.003 8.003 0 0 1 5.546-6.631c.712.389 1.516.631 2.385.631s1.673-.242 2.385-.631A8.004 8.004 0 0 1 23.931 24H8.069z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelSvgrepoCom);
export default __webpack_public_path__ + "static/media/channel-svgrepo-com.f68daadfd98b7e2a3cc93592a398c4f6.svg";
export { ForwardRef as ReactComponent };